export function getFontColorClassName(tags: string[]) {
  if (tags.includes('safety')) {
    return 'text-blue600'
  } else if (tags.includes('efficacy')) {
    return 'text-hope900'
  } else {
    return 'text-seaGreen800'
  }
}
